import { RootState } from 'src/store';

import { IProviderListData } from '../providersPayment/types';

export const selectProvidersLoading = (state: RootState): boolean => state.providersPayout.isLoading;
export const selectProvidersLoaded = (state: RootState): boolean => state.providersPayout.isLoaded;
export const selectProvidersMerchantsData = (state: RootState): IProviderListData => state.providersPayout.merchantAccounts;
